module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "fronthead"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/04_intro#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/05_c1#c1"
    }
  }, [_vm._v("Chapter 1 - Meeting the Dogg Father")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_c2#c2"
    }
  }, [_vm._v("Chapter 2 - Getting Snoop to Playboy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_c3#c3"
    }
  }, [_vm._v("Chapter 3 - Trial run & Carmelo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_c4#c4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4 - Buckwild Bus Tour")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_c5#c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 - Buckwild Temptations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_c6#c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 - Playboy 50"), _c('sup', [_vm._v("th")]), _vm._v(" & Melyssa Ford")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_c7#c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 - The Roadshow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_c8#c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 - Studio Sessions with Snoop")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_c9#c9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9 - Mase the Holy Freak")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_c10#c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10 - Anna Nicole Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_c11#c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11 - Fight Night at the Vibe Awards")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_c12#c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12 - MTV New Year’s Eve 2004/Super Bowl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_c13#c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13 - Pitching Shows with/The Firm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_c14#c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14 - How the West was One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_c15#c15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15 - Atlanta with BMF")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_c16#c16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16 - BET Awards 2005 & Hoopz")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/21_c17#c17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17 - Hurricane Katrina")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/22_c18#c18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18 - Boss ‘N Up Movie & Tour in Japan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/23_c19#c19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19 - Australia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/24_c20#c20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20 - MTV Australia & Russell Crowe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/25_c21#c21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21 - Auckland/The Friendly Skies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/26_c22#c22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22 - Private Jets & Hotels Suites")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/27_c23#c23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23 - Snoop’s Youth Football")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/28_c24#c24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24 - Michelle the Stallion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/29_c25#c25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25 - Ray J & Kim K")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/30_c26#c26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26 - A New Edition Wedding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/31_c27#c27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27 - Bad Feeling")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/32_c28#c28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28 - Hemmed Up at Heathrow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/33_c29#c29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29 - South Africa & Leonardo DiCaprio")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/34_c30#c30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30 - South Africa II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/35_c31#c31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31 - The End of the Road")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/36_bonus#bonus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bonus Chapter - My Stevie Wonder Encounters")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fdb31ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/03_toc.vue
// module id = 69
// module chunks = 0